import React, { Dispatch, SetStateAction } from "react";
import BackButton from "../components/BackButton";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { useMetaTags } from '../utils/useMetaTags';
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import { Wavedivider } from "../components/Wavedivider";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import YouTubeEmbed from "../components/YouTubeEmbed";
import { CalloutLink } from "../components/CalloutLink";
import { QuoteBlock } from "../components/QuoteBlock";

function Book2(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_BOOK2_PASSWORDS
      );
      
      useMetaTags({
        title: 'bookreport - Lynkim',
        description: '우리가 빛의 속도로 갈 수 없다면',
        image: '/ogimage.png',
      });
      
      return (
        <>
        {/* <ProtectedPage password={hashedPasswords} description="이번 가을에 단풍을 보러 간 곳"> */}
          <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
          <div className='fadeIn '>
            <ArticleTitle
              title={'우리가 빛의 속도로 갈 수 없다면'}
              titleEn={'If We Cannot Travel at the Speed of Light'}
              description={<div>가능성에 집중하기보다 중요한 가치에 집착하기</div>}
              descriptionEn={<div>Holding on to what matters rather than chasing possibility</div>}
              category={'book report'}
              date={'2025.09.01.'}
            //   thumbnail={image2}
        />
          </div>
          <Wavedivider/>
          <div className='articleLayout'>
          <ArticleTextSection 
                description=
                  {<div>
                    김초엽의 단편소설집 “우리가 빛의 속도로 갈 수 없다면”이라는 책을 추천 받아서 읽었다. 단편 하나하나가 기억에 남을 정도로 좋았는데, 그중 “우리가 빛의 속도로 갈 수 없다면”과 “감정의 물성”이 가장 인상에 남는 것 같다. 
                    <br/>
                  두 소설을 읽고나서 나에게 스스로 질문을 던지게 되었는데,
                  <br/><br/><b>
                  1. 절대 이루거나 도달하지 못함을 인지하더라도, 정말로 원하는 것이 있다면 할 것인가? <br/>
                  2. 우울함의 감정을 원할 때 느낄 수 있다면, 나는 우울한 감정 소유하려고 할 것인가?
                  </b><br/><br/>
                  나는 지금껏 이룰 수 없는 것이라는 부담감 때문에, 정말로 하고 싶은 것을 시작하거나, 제대로 끝까지 해보지 않은 것 같다. 나는 <a href="https://www.aladin.co.kr/shop/wproduct.aspx?ISBN=8982053318" target="_blank">“숨결이 바람이 될 때”</a>라는 책을 정말 좋아하는데, 인생에서 선택의 기로에 놓였다고 한다면 꼭 추천하는 책이다. 

                  내가 만약 앞으로의 70년 삶을 계획하고 살아가고 있었는데, 그 삶이 고작 1년 남았다고 한다면 어떻게 살 것인가? 

                  우리가 빛의 속도로 갈 수 없다면의 주인공도 꼭 가고 싶은 별에 도달하고 싶어서, 인간이 살아갈 수 있는 수명보다 더 멀리 떨어져있어 결국은 보지 못하고 죽을 것을 알면서도 기꺼이 별을 향해 출발하는 것처럼, 그렇게 중요하게 생각하는 삶의 가치에 집중해서 살아가야 하는게 아닐까?
                  <br/><br/>
                  감정의 물성에서의 사람들은 자신의 감정을 그저 소유하고 통제할 수 있음에 돈을 지불하고, 긍정적인 감정 뿐만 아니라 우울함이라는 부정적인 감정에 조차 돈을 지불하고 소유하고 통제하고자 했다. 만약 나에게 감정을 소유할 수 있는 기회가 있다면 구매할 것인가? 

                  가끔은 잘못된 방식으로 나의 감정을 다스릴 때가 있는 것 같다. 어떻게 보면 자해와 같은 행동이라고 생각한다. 

                  다른 사람에게 비난을 받고 싶어서 비난받을 행동을 일부러 하기도 한다. 생각해보면 그러지 않아도 된다는 위로가 필요했던 것 같다. 그건 잘못된 행동이야, 그렇게까지 하지 않아도 돼. 라는 말을 들으면서 상대방도 나와 같은 가치를 향유하고 있음을 느끼고 싶었던 것 같기도 하다. 

                  하지만 잘못된 방법으로 진심을 표현을 하거나, 그 마음을 직접 이야기하지 않으면 상대는 오해하고, 알아채지 못한다. 

                  감정을 다스리거나, 위로 받고 싶을 때, 더 현명하게 있는 그대로 드러낼 수 있을까?
                  </div>} 
            />
            <CalloutLink href="https://product.kyobobook.co.kr/detail/S000001935245" target="_blank">
                우리가 빛의 속도로 갈 수 없다면 - 김초엽 
                </CalloutLink>
          <BackButton/>
          {/* </ProtectedPage> */}
        </div>
        </>
      )
  }
  
  export default Book2;